module.exports = __webpack_public_path__ + "static/media/aside-image.89fe3307.png";